module.exports = __webpack_public_path__ + "static/media/mainSlide6.796f6883.jpg";